import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { Modal, Button } from "react-bootstrap";
import { getSpaPathPrefix } from '../../../resources/Constants';
import "../facturacion/ModalExitoFacturacion.css";
import "../facturacion/ModalFacturacionDs.css";
import { FORMA_PAGO_OPCIONES, getFormaPagoTexto } from '../../../utils/formasPago';

const parseMontoRecibo = (raw) => {
    if (raw === '' || raw == null) return 0;
    const digits = String(raw).replace(/\D/g, '');
    if (digits === '') return 0;
    const n = parseInt(digits, 10);
    return Number.isFinite(n) ? n : 0;
};

function EstadoCuentaPaciente() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [paciente, setPaciente] = useState(null);
    const [facturas, setFacturas] = useState([]);
    const [presupuestos, setPresupuestos] = useState([]);
    const [presupuestosActivos, setPresupuestosActivos] = useState([]);
    const [saldoTotalPresupuestos, setSaldoTotalPresupuestos] = useState(0);
    const [saldoTotal, setSaldoTotal] = useState(0);
    const [usuarios, setUsuarios] = useState([]);

    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const pacienteId = queryParams.get('id');

    // Modal Recibo de Caja
    const [showModalRecibo, setShowModalRecibo] = useState(false);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
    const [valorRecibo, setValorRecibo] = useState('');
    const [medioPago, setMedioPago] = useState('10');
    const [fechaPago, setFechaPago] = useState(new Date().toISOString().split('T')[0]);
    const [observacionesRecibo, setObservacionesRecibo] = useState('');

    // Modal Nota Crédito Electrónica
    const [showModalNotaCredito, setShowModalNotaCredito] = useState(false);
    const [prefijos, setPrefijos] = useState([]);
    const [prefijoSeleccionado, setPrefijoSeleccionado] = useState('');
    const [numeroNotaCredito, setNumeroNotaCredito] = useState('');
    const [fechaNotaCredito, setFechaNotaCredito] = useState(new Date().toISOString().split('T')[0]);
    const [tipoNotaCredito, setTipoNotaCredito] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCredito, setValorNotaCredito] = useState('');
    const [motivoNotaCredito, setMotivoNotaCredito] = useState('');
    const [loadingNC, setLoadingNC] = useState(false);
    const [notasCreditoExistentes, setNotasCreditoExistentes] = useState([]);
    const [sumaNotasCreditoExistentes, setSumaNotasCreditoExistentes] = useState(0);
    const MSG_NC_YA_REGISTRADA = 'Esta factura ya tiene Nota Crédito electrónica registrada. Actualice el listado. Si acaba de enviar una NC y la DIAN presenta demoras, espere un rato para visualizar los cambios.';

    const reconciliarNcAlAbrirModal = async (factura, notas, userdata) => {
        if (!notas || notas.length === 0) {
            return { continuar: true, notas: [] };
        }
        try {
            const syncRes = await axios.post(`/nota-credito/sincronizar-estado/${factura.id}?uid=${userdata.user_id}`);
            const data = syncRes.data || {};
            if (data.estado_actualizado) {
                return { continuar: false, sincronizado: true, message: data.message };
            }
            const notasRestantes = data.notas || [];
            if (data.puede_reenviar && notasRestantes.length === 0) {
                return { continuar: true, notas: [] };
            }
            if (parseInt(data.nuevo_estado, 10) === 3) {
                return { continuar: false, yaAnulada: true };
            }
            return { continuar: false, bloqueado: true, notas: notasRestantes.length ? notasRestantes : notas };
        } catch (error) {
            console.warn('Error sincronizando NC:', error);
            return { continuar: false, bloqueado: true, notas };
        }
    };

    // Modal Ver Recibos
    const [showModalRecibos, setShowModalRecibos] = useState(false);
    const [recibosFactura, setRecibosFactura] = useState([]);
    const [errorFacturas, setErrorFacturas] = useState(null);

    // Modal Éxito Recibo
    const [showModalExitoRecibo, setShowModalExitoRecibo] = useState(false);
    const [reciboGuardado, setReciboGuardado] = useState(null);

    // Modal Nota Crédito No Electrónica
    const [showModalNotaCreditoNE, setShowModalNotaCreditoNE] = useState(false);
    const [tipoNotaCreditoNE, setTipoNotaCreditoNE] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCreditoNE, setValorNotaCreditoNE] = useState('');
    const [motivoNotaCreditoNE, setMotivoNotaCreditoNE] = useState('');
    const [fechaNotaCreditoNE, setFechaNotaCreditoNE] = useState(new Date().toISOString().split('T')[0]);
    const [consecutivoNCNE, setConsecutivoNCNE] = useState(null); // Datos del consecutivo
    const [loadingNCNE, setLoadingNCNE] = useState(false);

    // Dropdown Nueva Factura
    const [showDropdownFactura, setShowDropdownFactura] = useState(false);

    // Modal de acciones rápidas por fila
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [tipoAccionSeleccionada, setTipoAccionSeleccionada] = useState('');
    const [registroAccion, setRegistroAccion] = useState(null);

    // Acordeón: presupuestos con facturas asociadas
    const [presupuestosExpandidos, setPresupuestosExpandidos] = useState({});
    const [seccionesAbiertas, setSeccionesAbiertas] = useState({
        activos: false,
        facturas: false,
        presupuestos: false
    });

    const filtrosVacios = { fechaDesde: '', fechaHasta: '', profesional: '', estado: '', busqueda: '' };
    const [filtrosActivos, setFiltrosActivos] = useState({ ...filtrosVacios });
    const [filtrosFacturas, setFiltrosFacturas] = useState({ ...filtrosVacios });
    const [filtrosPresupuestos, setFiltrosPresupuestos] = useState({ ...filtrosVacios });
    const [filtrosVisibles, setFiltrosVisibles] = useState({
        activos: false,
        facturas: false,
        presupuestos: false
    });

    const toggleSeccion = (key) => {
        setSeccionesAbiertas(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const toggleFiltros = (key, e) => {
        e.stopPropagation();
        if (!seccionesAbiertas[key]) {
            setSeccionesAbiertas(prev => ({ ...prev, [key]: true }));
            setFiltrosVisibles(prev => ({ ...prev, [key]: true }));
            return;
        }
        setFiltrosVisibles(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const seccionTieneFiltros = (filtros) => Object.values(filtros).some(v => String(v || '').trim() !== '');

    // Modal Debug - Para mostrar respuestas de DIAN
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'success', 'error'

    // Paginación
    const [paginaActualFacturas, setPaginaActualFacturas] = useState(1);
    const [paginaActualPresupuestos, setPaginaActualPresupuestos] = useState(1);
    const registrosPorPagina = 10;

    // 🔒 Función helper para validar permisos
    const tienePermiso = (permiso) => {
        const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        return userdata.up && userdata.up.includes(permiso);
    };

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        // Verificar permisos
        const tienePermiso = userdata.up && (
            userdata.up.includes('crearPacientes') ||
            userdata.up.includes('ver_listado_facturas')
        );

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente:', error);
            });

        // Cargar usuarios del cliente
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando usuarios:', error);
            });

        // Cargar datos del paciente
        if (pacienteId) {
            axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteId}`)
                .then(response => {
                    if (response.status === 200 && response.data.length > 0) {
                        setPaciente(response.data[0]);
                    }
                })
                .catch(error => {
                    console.log('Error cargando paciente:', error);
                });

            // Cargar facturas del paciente usando el nuevo endpoint
            axios.get(`/facturas/paciente/${pacienteId}`)
                .then(response => {
                    if (response.status === 200) {
                        setFacturas(response.data);

                        // Calcular saldo total pendiente (usar == para comparar con strings/numbers)
                        const saldo = response.data
                            .filter(f => f.estado == 2 || f.estado == 5)
                            .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                        setSaldoTotal(saldo);
                    }
                })
                .catch(error => {
                    console.log('Error cargando facturas:', error);
                    if (error.response && error.response.status === 403) {
                        setErrorFacturas('No tienes permiso para ver facturas. Contacta al administrador para obtener el permiso "ver_listado_facturas".');
                    } else if (error.response && error.response.status === 401) {
                        setErrorFacturas('Sesión expirada. Por favor inicia sesión nuevamente.');
                    }
                });

            // Cargar presupuestos del paciente usando el nuevo endpoint
            axios.get(`/presupuestos/paciente/${pacienteId}?uid=${userdata.user_id}`)
                .then(response => {
                    if (response.status === 200) {
                        setPresupuestos(response.data);
                    }
                })
                .catch(error => {
                    console.log('Error cargando presupuestos:', error);
                });

            // Cargar presupuestos activos del paciente
            axios.get(`/presupuestos/paciente/${pacienteId}/activos`)
                .then(response => {
                    if (response.status === 200) {
                        setPresupuestosActivos(response.data.presupuestos || []);
                        setSaldoTotalPresupuestos(parseFloat(response.data.total_saldo_disponible || 0));
                    }
                })
                .catch(error => {
                    console.log('Error cargando presupuestos activos:', error);
                });
        }
    }, [pacienteId]);

    const getNombreCompleto = () => {
        if (!paciente) return '';
        return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
    };

    const esFacturaContado = (f) => (f?.tipo_pago || '').toLowerCase() === 'contado';

    const getValorTotalNum = (f) => parseFloat(f?.valor_total || 0) || 0;

    const getSaldoPendienteNum = (f) => {
        const raw = f?.valor_pendiente;
        if (raw === null || raw === undefined || raw === '') return getValorTotalNum(f);
        const p = parseFloat(raw);
        return Number.isFinite(p) ? p : getValorTotalNum(f);
    };

    const getImporteNcTipoTotal = (f) =>
        esFacturaContado(f) ? getValorTotalNum(f) : getSaldoPendienteNum(f);

    const mensajeClienteSinCodigoEstado = (msg) => {
        if (msg == null) return '';
        let s = String(msg);
        s = s.replace(/\bestado_actual\s*[:=]\s*\d+/gi, '');
        s = s.replace(/\bestado\s*[:=]\s*\d+/gi, '');
        s = s.replace(/\bestado\s+\d+\b/gi, '');
        s = s.replace(/\ben estado\s+\d+\b/gi, 'en el estado actual');
        s = s.replace(/\(\s*estado\s*\d+\s*\)/gi, '');
        s = s.replace(/[,\s]+([,.])/g, '$1');
        s = s.replace(/\s{2,}/g, ' ').replace(/^[\s,;:.-]+|[\s,;:.-]+$/g, '').trim();
        return s || 'Operación no completada. Intente de nuevo o contacte soporte.';
    };

    const recargarFacturasPaciente = async () => {
        if (!pacienteId) return;
        try {
            const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
            if (facturaResponse.status === 200) {
                setFacturas(facturaResponse.data);
                const saldo = facturaResponse.data
                    .filter(f => f.estado === 2 || f.estado === 5)
                    .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                setSaldoTotal(saldo);
            }
        } catch (error) {
            console.error('Error recargando facturas:', error);
        }
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 0: return 'estado-chip generado';
            case 1: return 'estado-chip activo';
            case 2: return 'estado-chip por-cobrar';
            case 3: return 'estado-chip anulado';
            case 4: return 'estado-chip activo';
            case 5: return 'estado-chip por-cobrar';
            case 6: return 'estado-chip error';
            default: return 'estado-chip generado';
        }
    };

    const getNestedEstadoChip = (estado) => {
        switch (estado) {
            case 1:
            case 4:
                return 'nested-chip cobrada';
            case 2:
            case 5:
                return 'nested-chip por-cobrar';
            case 3:
                return 'nested-chip anulada';
            case 6:
                return 'nested-chip error';
            default:
                return 'nested-chip generada';
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO');
    };

    const esFacturaBorrador = (factura) => {
        const est = parseInt(factura?.estado, 10);
        return est === 0 || est === 7;
    };

    const getFacturasDePresupuesto = (presupuestoId) => {
        const id = parseInt(presupuestoId, 10);
        if (!id) return [];
        return facturas.filter(f => parseInt(f.presupuesto_id, 10) === id && !esFacturaBorrador(f));
    };

    const togglePresupuestoExpandido = (presupuestoId) => {
        setPresupuestosExpandidos(prev => ({
            ...prev,
            [presupuestoId]: !prev[presupuestoId]
        }));
    };

    const crearFactura = () => {
        history.push(`/crear-factura?paciente_id=${pacienteId}`);
    };

    const crearPresupuesto = () => {
        history.push(`/crear-presupuesto?paciente_id=${pacienteId}`);
    };

    const vistaPreviaPresupuesto = (presupuestoId) => {
        const prefix = getSpaPathPrefix();
        window.open(`${window.location.origin}${prefix}/#/vista-previa-presupuesto/${presupuestoId}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const cambiarEstadoPresupuesto = async (presupuestoId, nuevoEstado) => {
        const mensajes = { 1: '¿Aprobar este presupuesto?', 2: '¿Está seguro de ANULAR este presupuesto? El saldo se pondrá en $0.' };
        if (!window.confirm(mensajes[nuevoEstado] || '¿Cambiar estado?')) return;
        try {
            const response = await axios.put(`/presupuesto/${presupuestoId}/estado`, { estado: nuevoEstado });
            if (response.data.success) {
                // Recargar presupuestos
                const userdata = JSON.parse(localStorage.getItem('userdata'));
                const [presResp, activosResp] = await Promise.all([
                    axios.get(`/presupuestos/paciente/${pacienteId}?uid=${userdata.user_id}`),
                    axios.get(`/presupuestos/paciente/${pacienteId}/activos`)
                ]);
                if (presResp.status === 200) setPresupuestos(presResp.data);
                if (activosResp.status === 200) {
                    setPresupuestosActivos(activosResp.data.presupuestos || []);
                    setSaldoTotalPresupuestos(parseFloat(activosResp.data.total_saldo_disponible || 0));
                }
            }
        } catch (error) {
            alert('Error: ' + (error.response?.data?.message || error.message));
        }
    };

    // ==========================================
    // Funciones de ListadoFacturas
    // ==========================================

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id == usuarioId); // Usar == en lugar de === para comparación flexible
        return usuario ? usuario.name : 'N/A';
    };

    const abrirModalRecibo = (factura) => {
        setFacturaSeleccionada(factura);
        setValorRecibo('');
        setMedioPago('10');
        setFechaPago(new Date().toISOString().split('T')[0]);
        setObservacionesRecibo('');
        setShowModalRecibo(true);
    };

    const handleValorReciboChange = (e) => {
        const digits = e.target.value.replace(/\D/g, '');
        if (digits === '') {
            setValorRecibo('');
            return;
        }
        const num = parseInt(digits, 10);
        setValorRecibo(Number.isFinite(num) ? num.toLocaleString('es-CO') : '');
    };

    const guardarRecibo = async () => {
        const valorPendiente = facturaSeleccionada.valor_pendiente || facturaSeleccionada.valor_total;
        const montoRecibo = parseMontoRecibo(valorRecibo);

        if (!montoRecibo || montoRecibo <= 0) {
            alert('Ingrese un valor válido');
            return;
        }

        if (montoRecibo > parseFloat(valorPendiente)) {
            alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(parseFloat(valorPendiente)).toLocaleString('es-CO')}`);
            return;
        }

        const reciboData = {
            factura_id: facturaSeleccionada.id,
            valor_recibido: montoRecibo,
            medio_pago: medioPago,
            fecha_pago: fechaPago,
            observaciones: observacionesRecibo
        };

        try {
            const response = await axios.post('/recibo-caja', reciboData);
            if (response.status === 200 || response.status === 201) {
                setShowModalRecibo(false);
                setReciboGuardado(response.data);
                setShowModalExitoRecibo(true);
                await recargarFacturasPaciente();
            }
        } catch (error) {
            alert('Error al registrar el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const vistaPrevia = (facturaId) => {
        const url = `${window.location.origin}/smile/#/vista-previa-factura/${facturaId}`;
        window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const abrirModalNotaCredito = async (factura) => {
        setFacturaSeleccionada(factura);
        setPrefijoSeleccionado('');
        setNumeroNotaCredito('');
        setTipoNotaCredito('total');
        setValorNotaCredito(getImporteNcTipoTotal(factura));
        setMotivoNotaCredito('');
        setNotasCreditoExistentes([]);
        setSumaNotasCreditoExistentes(0);

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const [prefijosRes, ncRes] = await Promise.all([
                axios.get('/parametros-fev?uid=' + userdata.user_id),
                axios.get(`/nota-credito/por-factura/${factura.id}?uid=${userdata.user_id}`),
            ]);

            if (prefijosRes.status === 200) {
                const prefijosFiltrados = prefijosRes.data.filter(param =>
                    param.tipo === 'Nota Credito' &&
                    param.users_id == factura.users_id &&
                    param.estado == 1
                );
                setPrefijos(prefijosFiltrados);
            }

            if (ncRes.status === 200) {
                const notas = ncRes.data?.notas || [];
                setNotasCreditoExistentes(notas);
                setSumaNotasCreditoExistentes(parseFloat(ncRes.data?.suma_valor || 0));

                if (notas.length > 0) {
                    const sync = await reconciliarNcAlAbrirModal(factura, notas, userdata);
                    if (sync.sincronizado) {
                        alert(sync.message || 'Se actualizó el estado de la factura según la NC registrada.');
                        recargarFacturasPaciente();
                        return;
                    }
                    if (sync.yaAnulada) {
                        alert('Esta factura ya está anulada. Actualice el listado.');
                        recargarFacturasPaciente();
                        return;
                    }
                    if (sync.continuar) {
                        setNotasCreditoExistentes([]);
                        setSumaNotasCreditoExistentes(0);
                    } else if (sync.bloqueado) {
                        if (sync.notas?.length) {
                            setNotasCreditoExistentes(sync.notas);
                        }
                        alert(MSG_NC_YA_REGISTRADA);
                        return;
                    }
                }
            }
        } catch (error) {
            console.log('Error cargando datos de nota crédito:', error);
        }

        setShowModalNotaCredito(true);
    };

    const handlePrefijoChange = (e) => {
        const prefijoId = e.target.value;
        setPrefijoSeleccionado(prefijoId);

        if (prefijoId) {
            const prefijo = prefijos.find(p => p.id == prefijoId);
            if (prefijo) {
                setNumeroNotaCredito(prefijo.numero_factura);
            }
        } else {
            setNumeroNotaCredito('');
        }
    };

    const anularFactura = async (facturaId, facturaActual = null) => {
        const factura = facturaActual || facturas.find(f => f.id === facturaId);

        if (!factura) {
            alert('No se ha seleccionado ninguna factura');
            return;
        }

        // Mensaje diferente según el estado
        let mensaje = '¿Está seguro de anular esta factura?';
        if (factura.estado === 4) {
            mensaje = '¿Está seguro de anular esta factura de contado? Se generará una Nota Crédito automática para trazabilidad.';
        }

        if (!window.confirm(mensaje)) {
            return;
        }

        try {
            let response;

            if (factura.estado === 4) {
                // Estado 4: Usar endpoint especial que genera NC automática
                response = await axios.post('/anular-factura-contado', {
                    factura_id: facturaId
                });
            } else {
                // Otros estados: Anulación directa
                response = await axios.put(`/factura/${facturaId}/estado`, { estado: 3 });
            }

            if (response.status === 200 || response.data.success) {
                alert(response.data.message || 'Factura anulada exitosamente');
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            }
        } catch (error) {
            alert('Error al anular la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    const generarNotaCredito = async () => {
        if (loadingNC) return;

        if (!prefijoSeleccionado) {
            alert('Seleccione un prefijo');
            return;
        }

        if (!fechaNotaCredito) {
            alert('Seleccione una fecha');
            return;
        }

        if (!motivoNotaCredito.trim()) {
            alert('Ingrese el motivo de la nota crédito');
            return;
        }

        if (tipoNotaCredito === 'parcial' && esFacturaContado(facturaSeleccionada)) {
            alert('La nota crédito parcial aplica solo a facturas a crédito.');
            return;
        }

        if (esFacturaContado(facturaSeleccionada) && notasCreditoExistentes.length > 0) {
            alert(MSG_NC_YA_REGISTRADA);
            return;
        }

        if (tipoNotaCredito === 'parcial') {
            const valor = parseFloat(valorNotaCredito);
            const saldoPendiente = getSaldoPendienteNum(facturaSeleccionada);

            if (!valorNotaCredito || valor <= 0) {
                alert('Ingrese un valor válido para la nota crédito');
                return;
            }

            if (valor > saldoPendiente) {
                alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(saldoPendiente).toLocaleString('es-CO')}`);
                return;
            }
        }

        const mensajeConfirmacion = tipoNotaCredito === 'total'
            ? '¿Está seguro de generar una Nota Crédito TOTAL? Esta acción no se puede deshacer.\n\nSi la DIAN tarda, no envíe otra NC: espere y actualice el listado.'
            : `¿Está seguro de generar una Nota Crédito PARCIAL por $${Math.round(parseFloat(valorNotaCredito)).toLocaleString('es-CO')}? Esta acción no se puede deshacer.`;

        if (!window.confirm(mensajeConfirmacion)) {
            return;
        }

        const notaCreditoData = {
            factura_id: facturaSeleccionada.id,
            parametrosfev_id: prefijoSeleccionado,
            motivo: motivoNotaCredito,
            fecha_emision: fechaNotaCredito,
            tipo: tipoNotaCredito,
            valor: tipoNotaCredito === 'parcial' ? parseFloat(valorNotaCredito) : null
        };

        setLoadingNC(true);
        try {
            const response = await axios.post('/nota-credito/enviar-dian-directo', notaCreditoData);

            setShowModalNotaCredito(false);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: response.data.message,
                    uuid: response.data.uuid,
                    cufe: response.data.uuid,
                    numero_nc: response.data.numero_nc,
                    recibos_anulados: response.data.recibos_anulados,
                    facturaId: facturaSeleccionada.id,
                    pdf_url: response.data.pdf_path || null,
                    xml_url: response.data.xml_path || null,
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    titulo: 'No se pudo completar la Nota Crédito',
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            }

            await recargarFacturasPaciente();

            setPrefijoSeleccionado('');
            setNumeroNotaCredito('');
            setFechaNotaCredito(new Date().toISOString().split('T')[0]);
            setTipoNotaCredito('total');
            setValorNotaCredito('');
            setMotivoNotaCredito('');
            setNotasCreditoExistentes([]);
            setSumaNotasCreditoExistentes(0);

        } catch (error) {
            console.error('Error al generar nota crédito:', error);
            setShowModalNotaCredito(false);

            setDebugType('error');
            setDebugData({
                titulo: 'Error al enviar Nota Crédito',
                message: (error.response?.data?.message || error.message)
                    + ' Actualice el listado antes de reintentar; puede que la primera NC ya se haya registrado.',
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data,
                facturaId: facturaSeleccionada.id
            });
            setShowModalDebug(true);
            await recargarFacturasPaciente();
        } finally {
            setLoadingNC(false);
        }
    };

    const verRecibos = async (factura) => {
        setFacturaSeleccionada(factura);

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.get(`/recibos-caja/${factura.id}?uid=${userdata.user_id}`);
            if (response.status === 200) {
                setRecibosFactura(response.data);
                setShowModalRecibos(true);
            }
        } catch (error) {
            alert('Error al cargar los recibos: ' + (error.response?.data?.message || error.message));
        }
    };

    const getMedioPagoTexto = (codigo) => getFormaPagoTexto(codigo);

    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const anularRecibo = async (reciboId) => {
        if (!window.confirm('¿Está seguro de anular este recibo?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        // Mantener el estado actual según el tipo de factura
        // Estado 2: Por Cobrar (Electrónica) - mantener en 2
        // Estado 5: Por Cobrar (No Electrónica) - mantener en 5
        const estadoDestino = facturaSeleccionada.estado === 5 ? 5 : 2;

        try {
            const response = await axios.put(`/recibo-caja/${reciboId}/anular?uid=${userdata.user_id}`,
                { estado_factura_destino: estadoDestino }
            );
            if (response.status === 200) {
                alert('Recibo anulado exitosamente');
                verRecibos(facturaSeleccionada);
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            }
        } catch (error) {
            alert('Error al anular el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const vistaPreviaRecibo = async (recibo) => {
        let pacienteData = paciente;

        // Cargar datos completos del paciente si es necesario
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${paciente?.id}`);
            if (response.data && response.data.length > 0) {
                pacienteData = response.data[0];
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = pacienteData ? `${pacienteData.primer_nombre || ''} ${pacienteData.segundo_nombre || ''} ${pacienteData.primer_apellido || ''} ${pacienteData.segundo_apellido || ''}`.trim() : getNombreCompleto();

        // Obtener nombre del facturador
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // BANNER: RECIBO DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBO DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // Datos del recibo en tabla
        const datosReciboHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">RECIBO #</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${recibo.numero_recibo}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA PAGO</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(recibo.fecha_pago)}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FORMA DE PAGO</td>
                        <td style="background-color: #ffffff; width: 19%; padding: 6px; border: 1px solid #dee2e6;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td colspan="5" style="background-color: #ffffff; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibo = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReciboHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit()}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${pacienteData ? (pacienteData.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${pacienteData ? (pacienteData.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${pacienteData ? (pacienteData.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(pacienteData)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Concepto</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="border: 1px solid #dee2e6; padding: 8px; background-color: #ffffff; font-size: 12px;">Abono a Factura N° ${facturaSeleccionada?.numero_factura || ''}</td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; background-color: #ffffff; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif; white-space: nowrap;">Total:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    ${recibo.observaciones ? `
                    <div style="margin-top: 20px;">
                        <h6 style="font-size: 14px; font-weight: bold;">Observaciones:</h6>
                        <p style="font-size: 12px;">${recibo.observaciones}</p>
                    </div>
                    ` : ''}

                    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px;">
                        <p style="color: #666; margin-bottom: 30px; font-size: 12px;">Recibí conforme el valor arriba mencionado</p>
                        <div style="margin-top: 50px;">
                            <div style="border-top: 1px solid #333; width: 200px; margin: 0 auto;"></div>
                            <p style="margin-top: 5px; color: #666; font-size: 12px;">Firma del Paciente</p>
                        </div>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=800,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibo de Caja N° ${recibo.numero_recibo}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibo}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const construirDireccionCompleta = (paciente) => {
        if (!paciente) return '';
        const partes = [];
        if (paciente.direccion) partes.push(paciente.direccion);
        if (paciente.zona) partes.push(paciente.zona);
        if (paciente.nombre_ciudad_residencia) partes.push(paciente.nombre_ciudad_residencia);
        if (paciente.nombre_departamento_residencia) partes.push(paciente.nombre_departamento_residencia);
        if (paciente.nombre_pais_residencia) partes.push(paciente.nombre_pais_residencia);
        return partes.join(', ') || paciente.direccion || '';
    };

    const obtenerNit = () => {
        if (client?.numero_documento) {
            return client.digito_verificacion
                ? `${client.numero_documento}-${client.digito_verificacion}`
                : client.numero_documento;
        }
        return '';
    };

    const abrirModalAcciones = (tipo, registro) => {
        setTipoAccionSeleccionada(tipo);
        setRegistroAccion(registro);
        setShowModalAcciones(true);
    };

    const cerrarModalAcciones = () => {
        setShowModalAcciones(false);
        setTipoAccionSeleccionada('');
        setRegistroAccion(null);
    };

    const reenviarFacturaDian = async (facturaId) => {
        if (!window.confirm('¿Está seguro de reintentar el envío de esta factura a la DIAN?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.post(`/factura/${facturaId}/enviar-dian`, {});

            console.log('Respuesta completa de enviar-dian:', response.data);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Factura enviada exitosamente a la DIAN',
                    uuid: response.data.uuid,
                    estado: response.data.estado,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message || 'Error al enviar a la DIAN',
                    response: response.data.response || response.data.error,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    fullError: response.data,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN (catch):', error);

            const errorData = {
                message: error.response?.data?.message || error.message || 'Error al enviar a la DIAN',
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                status_code: error.response?.status || error.response?.data?.status_code,
                fullError: error.response?.data || error,
                facturaId: facturaId
            };

            setDebugType('error');
            setDebugData(errorData);
            setShowModalDebug(true);
        }
    };

    const abrirModalNotaCreditoNoElectronica = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        setFacturaSeleccionada(factura);
        setLoadingNCNE(true);

        try {
            const response = await axios.get('/consecutivo-nc-no-electronica?uid=' + userdata.user_id);
            if (response.data) {
                setConsecutivoNCNE(response.data);

                // Inicializar formulario
                setTipoNotaCreditoNE('total');
                setValorNotaCreditoNE(getImporteNcTipoTotal(factura));
                setMotivoNotaCreditoNE('');
                setFechaNotaCreditoNE(new Date().toISOString().split('T')[0]);

                setShowModalNotaCreditoNE(true);
            } else {
                alert('No se ha configurado un consecutivo para Notas Crédito No Electrónicas. Vaya a Configuración > Administrador Contable.');
            }
        } catch (error) {
            console.error(error);
            alert('Error al obtener consecutivo de Notas Crédito.');
        } finally {
            setLoadingNCNE(false);
        }
    };

    const generarNotaCreditoNE = async (e) => {
        e.preventDefault();

        if (!facturaSeleccionada || !consecutivoNCNE) return;

        const total = getValorTotalNum(facturaSeleccionada);
        const pend = getSaldoPendienteNum(facturaSeleccionada);
        const contado = esFacturaContado(facturaSeleccionada);
        const valorAplicar = parseFloat(valorNotaCreditoNE);

        if (tipoNotaCreditoNE === 'parcial' && contado) {
            alert('La nota crédito parcial aplica solo a facturas a crédito.');
            return;
        }

        const topeMax = contado ? total : pend;

        if (valorAplicar <= 0) {
            alert("El valor de la nota crédito debe ser mayor a 0.");
            return;
        }

        if (valorAplicar > topeMax + 100) {
            const etiqueta = contado ? 'el valor total de la factura' : 'el saldo pendiente';
            alert(`El valor de la nota crédito ($${valorAplicar.toLocaleString()}) no puede superar ${etiqueta} ($${Math.round(topeMax).toLocaleString('es-CO')}).`);
            return;
        }

        if (!motivoNotaCreditoNE.trim()) {
            alert("Debe ingresar un motivo para la nota crédito.");
            return;
        }

        if (!window.confirm(`¿Está seguro de generar una Nota Crédito por valor de $${valorAplicar.toLocaleString()}? Esta acción afectará el saldo y el consecutivo.`)) {
            return;
        }

        const data = {
            factura_id: facturaSeleccionada.id,
            valor: valorAplicar,
            motivo: motivoNotaCreditoNE,
            fecha: fechaNotaCreditoNE,
            consecutivo_id: consecutivoNCNE.id,
            tipo_nota: tipoNotaCreditoNE // 'total' o 'parcial'
        };

        setLoadingNCNE(true);

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.post('/nota-credito-no-electronica?uid=' + userdata.user_id, data);

            if (response.data.success) {
                alert('Nota Crédito generada exitosamente: ' + response.data.numero_nota);
                setShowModalNotaCreditoNE(false);
                await recargarFacturasPaciente();
            } else {
                alert(
                    'No se pudo generar la nota crédito. ' +
                    mensajeClienteSinCodigoEstado(response.data?.message || '')
                );
            }

        } catch (error) {
            console.error(error);
            alert(
                'No se pudo generar la Nota Crédito. ' +
                mensajeClienteSinCodigoEstado(error.response?.data?.message || error.message)
            );
        } finally {
            setLoadingNCNE(false);
        }
    };

    // ==========================================
    // Filtros y Paginación
    // ==========================================

    const parseFechaFiltro = (valor) => {
        if (!valor) return null;
        const d = new Date(valor);
        return Number.isNaN(d.getTime()) ? null : d;
    };

    const fechaEnRango = (fechaRaw, desde, hasta) => {
        if (!desde && !hasta) return true;
        if (!fechaRaw) return false;
        const fecha = new Date(fechaRaw);
        if (Number.isNaN(fecha.getTime())) return false;
        const dia = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
        if (desde) {
            const d = parseFechaFiltro(desde);
            if (d && dia < new Date(d.getFullYear(), d.getMonth(), d.getDate())) return false;
        }
        if (hasta) {
            const h = parseFechaFiltro(hasta);
            if (h && dia > new Date(h.getFullYear(), h.getMonth(), h.getDate())) return false;
        }
        return true;
    };

    const filtrarPresupuestosLista = (lista, filtros) => {
        const busqueda = (filtros.busqueda || '').trim().toLowerCase();
        return lista.filter(p => {
            if (!fechaEnRango(p.fecha_creacion, filtros.fechaDesde, filtros.fechaHasta)) return false;
            if (filtros.profesional && String(p.users_id) !== String(filtros.profesional)) return false;
            if (filtros.estado !== '' && String(p.estado) !== String(filtros.estado)) return false;
            if (busqueda) {
                const numero = String(p.numero_presupuesto || '').toLowerCase();
                const profesional = getNombreUsuario(p.users_id).toLowerCase();
                if (!numero.includes(busqueda) && !profesional.includes(busqueda)) return false;
            }
            return true;
        });
    };

    const filtrarFacturasLista = (lista, filtros) => {
        const busqueda = (filtros.busqueda || '').trim().toLowerCase();
        return lista.filter(f => {
            if (esFacturaBorrador(f)) return false;
            if (!fechaEnRango(f.fecha_emision, filtros.fechaDesde, filtros.fechaHasta)) return false;
            if (filtros.profesional && String(f.users_id) !== String(filtros.profesional)) return false;
            if (filtros.estado !== '' && String(f.estado) !== String(filtros.estado)) return false;
            if (busqueda) {
                const numero = `${f.prefijo || ''}-${f.numero_factura || ''}`.toLowerCase();
                const soloNumero = String(f.numero_factura || '').toLowerCase();
                const id = String(f.id || '');
                const profesional = getNombreUsuario(f.users_id).toLowerCase();
                const concepto = String(f.concepto_factura_nombre || '').toLowerCase();
                if (
                    !numero.includes(busqueda)
                    && !soloNumero.includes(busqueda)
                    && !id.includes(busqueda)
                    && !profesional.includes(busqueda)
                    && !concepto.includes(busqueda)
                ) return false;
            }
            return true;
        });
    };

    const presupuestosSaldoBase = presupuestos.filter(p => p.estado === 1 || p.estado === 2);
    const presupuestosActivosFiltrados = filtrarPresupuestosLista(presupuestosSaldoBase, filtrosActivos);
    const facturasFiltradas = filtrarFacturasLista(facturas, filtrosFacturas);
    const presupuestosFiltrados = filtrarPresupuestosLista(presupuestos, filtrosPresupuestos);

    const indiceUltimoRegistroFacturas = paginaActualFacturas * registrosPorPagina;
    const indicePrimerRegistroFacturas = indiceUltimoRegistroFacturas - registrosPorPagina;
    const facturasPaginadas = facturasFiltradas.slice(indicePrimerRegistroFacturas, indiceUltimoRegistroFacturas);
    const totalPaginasFacturas = Math.max(1, Math.ceil(facturasFiltradas.length / registrosPorPagina));

    const cambiarPaginaFacturas = (numeroPagina) => {
        setPaginaActualFacturas(numeroPagina);
    };

    const indiceUltimoRegistroPresupuestos = paginaActualPresupuestos * registrosPorPagina;
    const indicePrimerRegistroPresupuestos = indiceUltimoRegistroPresupuestos - registrosPorPagina;
    const presupuestosPaginados = presupuestosFiltrados.slice(indicePrimerRegistroPresupuestos, indiceUltimoRegistroPresupuestos);
    const totalPaginasPresupuestos = Math.max(1, Math.ceil(presupuestosFiltrados.length / registrosPorPagina));

    const cambiarPaginaPresupuestos = (numeroPagina) => {
        setPaginaActualPresupuestos(numeroPagina);
    };

    const actualizarFiltro = (setter, paginaSetter, campo, valor) => {
        setter(prev => ({ ...prev, [campo]: valor }));
        if (paginaSetter) paginaSetter(1);
    };

    const renderBarraFiltros = ({ filtros, setter, paginaSetter, labelBusqueda, placeholderBusqueda, opcionesEstado }) => (
        <div className="seccion-filtros">
            <div className="seccion-filtro-item">
                <label>Fecha desde</label>
                <input
                    type="date"
                    className="form-control form-control-sm"
                    value={filtros.fechaDesde}
                    onChange={(e) => actualizarFiltro(setter, paginaSetter, 'fechaDesde', e.target.value)}
                />
            </div>
            <div className="seccion-filtro-item">
                <label>Fecha hasta</label>
                <input
                    type="date"
                    className="form-control form-control-sm"
                    value={filtros.fechaHasta}
                    onChange={(e) => actualizarFiltro(setter, paginaSetter, 'fechaHasta', e.target.value)}
                />
            </div>
            <div className="seccion-filtro-item">
                <label>Profesional</label>
                <select
                    className="form-control form-control-sm"
                    value={filtros.profesional}
                    onChange={(e) => actualizarFiltro(setter, paginaSetter, 'profesional', e.target.value)}
                >
                    <option value="">Todos</option>
                    {usuarios.map(u => (
                        <option key={u.id} value={u.id}>{u.name}</option>
                    ))}
                </select>
            </div>
            <div className="seccion-filtro-item">
                <label>Estado</label>
                <select
                    className="form-control form-control-sm"
                    value={filtros.estado}
                    onChange={(e) => actualizarFiltro(setter, paginaSetter, 'estado', e.target.value)}
                >
                    <option value="">Todos</option>
                    {opcionesEstado.map(op => (
                        <option key={op.value} value={op.value}>{op.label}</option>
                    ))}
                </select>
            </div>
            <div className="seccion-filtro-item seccion-filtro-buscar">
                <label>{labelBusqueda}</label>
                <div className="input-group input-group-sm seccion-filtro-buscar-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder={placeholderBusqueda}
                        value={filtros.busqueda}
                        onChange={(e) => actualizarFiltro(setter, paginaSetter, 'busqueda', e.target.value)}
                    />
                    <div className="input-group-append">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Limpiar filtros"
                            onClick={() => {
                                setter({ ...filtrosVacios });
                                if (paginaSetter) paginaSetter(1);
                            }}
                        >
                            <i className="fas fa-trash-alt"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderBotonFiltro = (key, filtros) => (
        <button
            type="button"
            className={`btn-filtro-seccion${filtrosVisibles[key] || seccionTieneFiltros(filtros) ? ' activo' : ''}`}
            title="Filtros"
            onClick={(e) => toggleFiltros(key, e)}
        >
            <i className="fas fa-filter"></i>
        </button>
    );

    if (loggedIn && hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn && hasPermission) {
        return (
            <div className="hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .resumen-cuenta-row {
                        margin-bottom: 20px;
                    }
                    .resumen-cuenta-paciente-card,
                    .resumen-cuenta-saldo-card {
                        border-radius: 12px;
                        padding: 16px 18px;
                        box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
                        height: 100%;
                    }
                    .resumen-cuenta-paciente-card {
                        background: white;
                        border: 1px solid #e8eef3;
                    }
                    .resumen-cuenta-saldo-card {
                        background: #17a2b8;
                        border: 1px solid #17a2b8;
                        display: flex;
                        flex-direction: column;
                    }
                    .resumen-cuenta-paciente-card h5 {
                        color: #334155;
                        margin-bottom: 10px;
                        font-weight: 600;
                        border-bottom: 2px solid #17a2b8;
                        padding-bottom: 8px;
                        font-size: 1.05rem;
                    }
                    .resumen-cuenta-saldo-card h5 {
                        color: #fff;
                        margin-bottom: 10px;
                        font-weight: 600;
                        border-bottom: 2px solid #fff;
                        padding-bottom: 8px;
                        font-size: 1.05rem;
                    }
                    .paciente-datos-grid {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 8px 20px;
                        margin-top: 12px;
                    }
                    .paciente-datos-grid p {
                        margin-bottom: 0;
                        font-size: 0.82rem;
                        color: #495057;
                    }
                    .paciente-datos-grid strong {
                        color: #212529;
                        font-size: 0.84rem;
                    }
                    .nombre-paciente-highlight {
                        color: #17a2b8;
                        font-weight: 700;
                    }
                    .estado-cuenta-title {
                        font-size: 2rem;
                    }
                    .saldo-card-body {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 16px;
                        flex: 1;
                        padding: 18px 0 6px;
                    }
                    .resumen-cuenta-saldo-card h2 {
                        font-size: 2rem !important;
                        font-weight: 800 !important;
                        margin: 0;
                        color: #fff !important;
                        letter-spacing: -0.03em;
                        line-height: 1;
                    }
                    .seccion-filtros {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 10px;
                        align-items: flex-end;
                        padding: 12px 14px;
                        background: #f8fafc;
                        border-bottom: 1px solid #e8eef3;
                    }
                    .seccion-filtro-item {
                        min-width: 140px;
                        flex: 1 1 140px;
                    }
                    .seccion-filtro-item label {
                        display: block;
                        font-size: 0.68rem;
                        font-weight: 700;
                        color: #64748b;
                        text-transform: uppercase;
                        margin-bottom: 4px;
                    }
                    .seccion-filtro-item .form-control {
                        border-radius: 8px;
                        border-color: #dbe3ea;
                        font-size: 0.8rem;
                    }
                    .seccion-filtro-buscar {
                        flex: 1.4 1 180px;
                        min-width: 160px;
                    }
                    .seccion-filtro-buscar-group .form-control {
                        border-radius: 8px 0 0 8px;
                        border-color: #dbe3ea;
                    }
                    .seccion-filtro-buscar-group .btn {
                        border-radius: 0 8px 8px 0;
                        border-color: #dbe3ea;
                        color: #64748b;
                        background: #fff;
                        min-width: 34px;
                    }
                    .seccion-filtro-buscar-group .btn:hover {
                        background: #fef2f2;
                        color: #b91c1c;
                        border-color: #fecaca;
                    }
                    @media (max-width: 767px) {
                        .resumen-cuenta-saldo-card { margin-top: 12px; }
                        .resumen-cuenta-saldo-card h2 { font-size: 2rem !important; color: #fff !important; }
                        .paciente-datos-grid { grid-template-columns: 1fr; }
                    }
                    .presupuesto-expand-btn {
                        border: none;
                        background: transparent;
                        color: #17a2b8;
                        padding: 0 6px 0 0;
                        line-height: 1;
                        cursor: pointer;
                        width: 16px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .presupuesto-row-abierta td {
                        background: #f8fafc !important;
                    }
                    .presupuesto-row-abierta:hover {
                        background: #f8fafc !important;
                        box-shadow: none !important;
                    }
                    .presupuesto-row-abierta.fila-anulado:hover {
                        box-shadow: inset 4px 0 0 #dc3545 !important;
                    }
                    .presupuesto-facturas-row td {
                        background: #f8fafc !important;
                        white-space: normal !important;
                        padding: 0 14px 12px 14px !important;
                    }
                    .presupuesto-facturas-row:hover {
                        box-shadow: none !important;
                        background: #f8fafc !important;
                    }
                    .presupuesto-facturas-panel {
                        margin-left: 22px;
                        padding: 8px 10px 10px;
                        background: #f8fafc;
                        border: 1px solid #e2e8f0;
                        border-left: 3px solid #17a2b8;
                        border-radius: 8px;
                    }
                    .presupuesto-facturas-panel-title {
                        font-size: 0.7rem;
                        color: #64748b;
                        font-weight: 600;
                        margin-bottom: 6px;
                    }
                    .presupuesto-facturas-table {
                        width: 100%;
                        margin: 0;
                        background: #fff;
                        border: 1px solid #e8eef3;
                        border-radius: 6px;
                        overflow: hidden;
                    }
                    .presupuesto-facturas-table th {
                        background: #f1f5f9;
                        color: #94a3b8 !important;
                        font-size: 0.62rem !important;
                        font-weight: 600 !important;
                        text-transform: uppercase;
                        letter-spacing: 0.03em;
                        padding: 5px 8px !important;
                        border: none !important;
                    }
                    .presupuesto-facturas-table td {
                        padding: 5px 8px !important;
                        font-size: 0.72rem !important;
                        color: #475569;
                        border-top: 1px solid #f1f5f9 !important;
                        white-space: nowrap;
                        background: #fff;
                    }
                    .presupuesto-facturas-table td.concepto-cell {
                        white-space: nowrap;
                        max-width: 140px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .nested-chip {
                        display: inline-flex;
                        align-items: center;
                        padding: 1px 8px;
                        border-radius: 999px;
                        font-size: 0.62rem;
                        font-weight: 700;
                    }
                    .nested-chip.cobrada { color: #047857; background: #ecfdf5; }
                    .nested-chip.por-cobrar { color: #b45309; background: #fffbeb; }
                    .nested-chip.anulada { color: #b91c1c; background: #fef2f2; }
                    .nested-chip.generada { color: #64748b; background: #f1f5f9; }
                    .nested-chip.error { color: #b91c1c; background: #fef2f2; }
                    .custom-table {
                        width: 100%;
                        background: #fff;
                        table-layout: fixed;
                        min-width: 980px;
                    }
                    .custom-table thead th {
                        background: #f8f9fa; color: #7d7d7d !important; text-transform: uppercase;
                        font-size: 0.68rem !important; font-weight: 700 !important; padding: 11px 14px !important; border: none !important;
                    }
                    .custom-table tbody tr { border-bottom: 1px solid #f0f0f0; transition: all 0.2s; }
                    .custom-table tbody tr:hover { background-color: #f9fbff !important; box-shadow: inset 4px 0 0 #17a2b8; }
                    .custom-table tbody tr.fila-anulado:hover { background-color: #fff7f7 !important; box-shadow: inset 4px 0 0 #dc3545; }
                    .presupuesto-facturas-table tbody tr:hover { background-color: #f9fbff; box-shadow: inset 3px 0 0 #17a2b8; }
                    .presupuesto-facturas-table tbody tr.fila-anulado:hover { background-color: #fff7f7; box-shadow: inset 3px 0 0 #dc3545; }
                    .custom-table td {
                        padding: 9px 14px !important;
                        vertical-align: middle !important;
                        border: none !important;
                        font-size: 0.8rem !important;
                        white-space: nowrap;
                    }
                    .resumen-pill {
                        display: inline-flex;
                        align-items: center;
                        padding: 4px 10px;
                        border-radius: 999px;
                        font-size: 0.75rem;
                        font-weight: 700;
                        color: #1f2937;
                        background: #fff;
                        border: 1px solid #d1d5db;
                    }
                    .estado-chip {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        padding: 3px 10px;
                        border-radius: 999px;
                        font-size: 0.68rem;
                        font-weight: 700;
                        border: 1px solid transparent;
                        line-height: 1.2;
                    }
                    .estado-chip.generado { color: #6b7280; background: #f3f4f6; border-color: #d1d5db; }
                    .estado-chip.activo { color: #047857; background: #ecfdf5; border-color: #a7f3d0; }
                    .estado-chip.por-cobrar { color: #b45309; background: #fffbeb; border-color: #fde68a; }
                    .estado-chip.anulado { color: #b91c1c; background: #fef2f2; border-color: #fecaca; }
                    .estado-chip.error { color: #b91c1c; background: #fef2f2; border-color: #fecaca; }
                    .tipo-chip {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        padding: 3px 8px;
                        border-radius: 999px;
                        font-size: 0.67rem;
                        font-weight: 700;
                    }
                    .tipo-chip.elect { color: #0f766e; background: #ecfeff; border: 1px solid #99f6e4; }
                    .tipo-chip.no-elect { color: #374151; background: #f3f4f6; border: 1px solid #d1d5db; }
                    .badge-outline-secondary {
                        color: #6c757d;
                        border: 1px solid #6c757d;
                        background-color: transparent;
                    }
                    .badge-outline-success {
                        color: #28a745;
                        border: 1px solid #28a745;
                        background-color: transparent;
                    }
                    .badge-outline-warning {
                        color: #ffc107;
                        border: 1px solid #ffc107;
                        background-color: transparent;
                    }
                    .badge-outline-danger {
                        color: #dc3545;
                        border: 1px solid #dc3545;
                        background-color: transparent;
                    }
                    .badge-outline-info {
                        color: #17a2b8;
                        border: 1px solid #17a2b8;
                        background-color: transparent;
                    }
                    .btn-toolbar {
                        gap: 0.5rem;
                    }
                    .card-header.bg-gradient-light {
                        background: linear-gradient(135deg, #f6fcfd 0%, #e6f7f9 100%);
                        border-bottom: 2px solid #17a2b8;
                    }
                    .shadow-sm {
                        box-shadow: 0 0.125rem 0.25rem rgba(23, 162, 184, 0.1) !important;
                    }
                    .action-buttons { display: flex; flex-wrap: wrap; gap: 8px; }
                    .action-buttons .btn { border-radius: 10px; }
                    .seccion-accordion-header {
                        cursor: pointer;
                        user-select: none;
                    }
                    .seccion-accordion-header .card-title {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        margin-bottom: 0;
                    }
                    .seccion-count {
                        margin-left: auto;
                        font-size: 0.75rem;
                        font-weight: 700;
                        color: #0c5460;
                        background: #ecfeff;
                        border: 1px solid #99f6e4;
                        border-radius: 999px;
                        padding: 2px 10px;
                    }
                    .btn-filtro-seccion {
                        border: 1px solid #99f6e4;
                        background: #fff;
                        color: #0c5460;
                        border-radius: 8px;
                        width: 28px;
                        height: 28px;
                        padding: 0;
                        margin-left: 8px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.75rem;
                    }
                    .btn-filtro-seccion:hover,
                    .btn-filtro-seccion.activo {
                        background: #17a2b8;
                        border-color: #17a2b8;
                        color: #fff;
                    }
                    .card-primary.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .card-info.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .pagination .page-item.active .page-link {
                        background-color: #282828;
                        border-color: #282828;
                        color: #f6fcfd;
                    }
                    .pagination .page-link {
                        color: #282828;
                        border-color: #dee2e6;
                    }
                    .pagination .page-link:hover {
                        background-color: #f6fcfd;
                        border-color: #17a2b8;
                        color: #282828;
                    }
                    .pagination .page-item.disabled .page-link {
                        color: #6c757d;
                        background-color: #fff;
                        border-color: #dee2e6;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-pacientes">Pacientes</Link></li>
                                        <li className="breadcrumb-item"><Link to="/pacientes">Listar Pacientes</Link></li>
                                        <li className="breadcrumb-item active">Estado de Cuenta</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0 estado-cuenta-title">
                                        Estado de Cuenta - <span className="nombre-paciente-highlight">{getNombreCompleto()}</span>
                                    </h1>
                                </div>
                                <div className="col-sm-4 text-right">
                                    <Link to="/pacientes" className="btn btn-secondary">
                                        <i className="fas fa-arrow-left"></i> Volver
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">

                            {/* Información del Paciente + Saldo */}
                            <div className="row resumen-cuenta-row">
                                <div className="col-md-7 col-lg-8">
                                    <div className="resumen-cuenta-paciente-card">
                                        <h5><i className="fas fa-user"></i> Información del Paciente</h5>
                                        <div className="paciente-datos-grid">
                                            <p><strong>Documento:</strong> {paciente?.numero_documento || 'N/A'}</p>
                                            <p><strong>Teléfono:</strong> {paciente?.telefono || 'N/A'}</p>
                                            <p><strong>Celular:</strong> {paciente?.celular || 'N/A'}</p>
                                            <p><strong>Email:</strong> {paciente?.email || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 col-lg-4">
                                    <div className="resumen-cuenta-saldo-card">
                                        <h5><i className="fas fa-wallet"></i> Saldo Pendiente por Cancelar</h5>
                                        <div className="saldo-card-body">
                                            <h2>${Math.round(saldoTotalPresupuestos).toLocaleString('es-CO')}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {errorFacturas && (
                                <div className="alert alert-warning" role="alert">
                                    <i className="fas fa-exclamation-triangle mr-1"></i> {errorFacturas}
                                </div>
                            )}

                            {/* Botones de Acción */}
                            <div className="row mt-2 mb-3">
                                <div className="col-md-12">
                                    <div className="action-buttons" role="group">
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-success dropdown-toggle"
                                                type="button"
                                                onClick={() => setShowDropdownFactura(!showDropdownFactura)}
                                            >
                                                <i className="fas fa-plus"></i> Nueva Factura
                                            </button>
                                            {showDropdownFactura && (
                                                <div className="dropdown-menu show" style={{ position: 'absolute', left: 0 }}>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            setShowDropdownFactura(false);
                                                            crearFactura();
                                                        }}
                                                    >
                                                        <i className="fas fa-plus"></i> Electrónica
                                                    </button>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            setShowDropdownFactura(false);
                                                            history.push(`/crear-factura-no-electronica?paciente_id=${pacienteId}`);
                                                        }}
                                                    >
                                                        <i className="fas fa-plus"></i> No Electrónica
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        <button className="btn btn-info" onClick={crearPresupuesto}>
                                            <i className="fas fa-calculator"></i> Nuevo Presupuesto
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Sección Presupuestos Activos */}
                            <div className="card" style={{ borderColor: '#d1d5db', borderWidth: '1px', borderStyle: 'solid' }}>
                                <div
                                    className="card-header seccion-accordion-header"
                                    style={{ backgroundColor: '#eaeaea', borderBottom: '2px solid #17a2b8' }}
                                    onClick={() => toggleSeccion('activos')}
                                >
                                    <h3 className="card-title" style={{ color: '#1f2937' }}>
                                        <i className={`fas fa-chevron-${seccionesAbiertas.activos ? 'down' : 'right'} mr-2`}></i>
                                        <i className="fas fa-wallet mr-2"></i> Presupuestos Activos
                                        {presupuestosActivos.length > 0 && (
                                            <span className="resumen-pill ml-2">
                                                Saldo Pendiente por Cancelar: ${Math.round(saldoTotalPresupuestos).toLocaleString('es-CO')}
                                            </span>
                                        )}
                                        <span className="seccion-count">
                                            {presupuestosActivosFiltrados.length}
                                        </span>
                                        {renderBotonFiltro('activos', filtrosActivos)}
                                    </h3>
                                </div>

                                {seccionesAbiertas.activos && (
                                <>
                                {filtrosVisibles.activos && renderBarraFiltros({
                                    filtros: filtrosActivos,
                                    setter: setFiltrosActivos,
                                    paginaSetter: null,
                                    labelBusqueda: 'N° Presupuesto',
                                    placeholderBusqueda: 'N° Presupuesto',
                                    opcionesEstado: [
                                        { value: '1', label: 'Activo' },
                                        { value: '2', label: 'Anulado' }
                                    ]
                                })}
                                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                    {presupuestosActivosFiltrados.length === 0 ? (
                                        <div className="text-center p-4">
                                            <i className="fas fa-info-circle text-muted mr-1"></i>
                                            <span className="text-muted">No hay presupuestos de saldo registrados</span>
                                        </div>
                                    ) : (
                                        <table className="table custom-table mb-0">
                                            <colgroup>
                                                <col style={{ width: '14%' }} />
                                                <col style={{ width: '10%' }} />
                                                <col style={{ width: '16%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '12%' }} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>N° Presupuesto</th>
                                                    <th>Fecha</th>
                                                    <th>Profesional</th>
                                                    <th className="text-right">Total</th>
                                                    <th className="text-right">Pagado</th>
                                                    <th className="text-right">Saldo</th>
                                                    <th className="text-center">Estado</th>
                                                    <th className="text-center">Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {presupuestosActivosFiltrados.map(pres => {
                                                    const esActivo = parseInt(pres.estado) === 1;
                                                    const valorTotal = parseFloat(pres.valor_total || 0);
                                                    const valorPagado = parseFloat(pres.valor_consumido || 0);
                                                    const saldoPendiente = parseFloat(pres.saldo_disponible || 0);
                                                    const valorAnulado = esActivo ? 0 : (valorTotal - valorPagado);
                                                    const facturasAsociadas = getFacturasDePresupuesto(pres.id);
                                                    const tieneFacturas = facturasAsociadas.length > 0;
                                                    const expandido = !!presupuestosExpandidos[pres.id];
                                                    return (
                                                        <React.Fragment key={pres.id}>
                                                            <tr className={`${expandido ? 'presupuesto-row-abierta' : ''}${!esActivo ? ' fila-anulado' : ''}`}>
                                                                <td>
                                                                    {tieneFacturas && (
                                                                        <button
                                                                            type="button"
                                                                            className="presupuesto-expand-btn"
                                                                            title={expandido ? 'Ocultar facturas' : 'Ver facturas asociadas'}
                                                                            onClick={() => togglePresupuestoExpandido(pres.id)}
                                                                            aria-expanded={expandido}
                                                                        >
                                                                            <i className={`fas fa-chevron-${expandido ? 'down' : 'right'}`}></i>
                                                                        </button>
                                                                    )}
                                                                    <strong>{pres.numero_presupuesto}</strong>
                                                                    {tieneFacturas && (
                                                                        <span className="text-muted ml-1" style={{ fontSize: '0.72rem' }}>
                                                                            ({facturasAsociadas.length})
                                                                        </span>
                                                                    )}
                                                                </td>
                                                                <td>{formatearFecha(pres.fecha_creacion)}</td>
                                                                <td>{getNombreUsuario(pres.users_id)}</td>
                                                                <td className="text-right">${Math.round(valorTotal).toLocaleString('es-CO')}</td>
                                                                <td className="text-right" style={{ color: '#28a745', fontWeight: 'bold' }}>${Math.round(valorPagado).toLocaleString('es-CO')}</td>
                                                                <td className="text-right">
                                                                    {esActivo ? (
                                                                        <strong style={{ color: saldoPendiente > 0 ? '#dc3545' : '#28a745' }}>
                                                                            ${Math.round(saldoPendiente).toLocaleString('es-CO')}
                                                                        </strong>
                                                                    ) : (
                                                                        <span style={{ color: '#6c757d' }}>${Math.round(valorAnulado).toLocaleString('es-CO')}</span>
                                                                    )}
                                                                </td>
                                                                <td className="text-center">
                                                                    <span className={`estado-chip ${esActivo ? 'activo' : 'anulado'}`}>
                                                                        {esActivo ? 'Activo' : 'Anulado'}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-light shadow-sm"
                                                                        onClick={() => abrirModalAcciones('presupuesto', pres)}
                                                                        style={{ borderRadius: '8px', padding: '4px 12px', background: 'white', color: '#323a45', border: '1px solid #f0f0f0' }}
                                                                    >
                                                                        <i className="fas fa-ellipsis-v"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            {expandido && tieneFacturas && (
                                                                <tr className="presupuesto-facturas-row">
                                                                    <td colSpan="8">
                                                                        <div className="presupuesto-facturas-panel">
                                                                            <div className="presupuesto-facturas-panel-title">
                                                                                Facturas asociadas a {pres.numero_presupuesto}
                                                                            </div>
                                                                            <table className="presupuesto-facturas-table">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>N° Factura</th>
                                                                                        <th>Fecha</th>
                                                                                        <th>Concepto</th>
                                                                                        <th>Forma de pago</th>
                                                                                        <th className="text-right">Total</th>
                                                                                        <th>Tipo</th>
                                                                                        <th>Estado</th>
                                                                                        <th className="text-center">Acciones</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {facturasAsociadas.map(factura => (
                                                                                        <tr
                                                                                            key={`pres-fact-${factura.id}`}
                                                                                            className={parseInt(factura.estado, 10) === 3 ? 'fila-anulado' : ''}
                                                                                        >
                                                                                            <td>
                                                                                                {factura.prefijo && factura.numero_factura ? (
                                                                                                    <strong>{factura.prefijo}-{factura.numero_factura}</strong>
                                                                                                ) : factura.numero_factura ? (
                                                                                                    <strong>{factura.numero_factura}</strong>
                                                                                                ) : (
                                                                                                    <strong className="text-muted">#{factura.id}</strong>
                                                                                                )}
                                                                                            </td>
                                                                                            <td>{formatearFecha(factura.fecha_emision)}</td>
                                                                                            <td
                                                                                                className="concepto-cell"
                                                                                                title={factura.concepto_factura_nombre || ''}
                                                                                            >
                                                                                                {factura.concepto_factura_nombre || '—'}
                                                                                            </td>
                                                                                            <td>
                                                                                                {factura.forma_pago && factura.forma_pago !== 'PENDIENTE'
                                                                                                    ? getMedioPagoTexto(factura.forma_pago)
                                                                                                    : '—'}
                                                                                            </td>
                                                                                            <td className="text-right">
                                                                                                ${Math.round(parseFloat(factura.valor_total || 0)).toLocaleString('es-CO')}
                                                                                            </td>
                                                                                            <td>
                                                                                                {[4, 5].includes(factura.estado) ? 'No electrónica' : 'Electrónica'}
                                                                                            </td>
                                                                                            <td>
                                                                                                <span className={getNestedEstadoChip(factura.estado)}>
                                                                                                    {getEstadoTexto(factura.estado)}
                                                                                                </span>
                                                                                            </td>
                                                                                            <td className="text-center">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-sm btn-light shadow-sm"
                                                                                                    onClick={() => abrirModalAcciones('factura', factura)}
                                                                                                    style={{ borderRadius: '6px', padding: '2px 8px', background: 'white', color: '#323a45', border: '1px solid #e2e8f0' }}
                                                                                                >
                                                                                                    <i className="fas fa-ellipsis-v"></i>
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                </>
                                )}
                            </div>

                            {/* Tabla de Facturas Generadas */}
                            <div className="card card-info card-outline">
                                <div
                                    className="card-header seccion-accordion-header"
                                    onClick={() => toggleSeccion('facturas')}
                                >
                                    <h3 className="card-title">
                                        <i className={`fas fa-chevron-${seccionesAbiertas.facturas ? 'down' : 'right'} mr-2`}></i>
                                        <i className="fas fa-file-invoice-dollar mr-2"></i> Facturas Generadas
                                        <span className="seccion-count">{facturasFiltradas.length}</span>
                                        {renderBotonFiltro('facturas', filtrosFacturas)}
                                    </h3>
                                </div>
                                {seccionesAbiertas.facturas && (
                                <>
                                {filtrosVisibles.facturas && renderBarraFiltros({
                                    filtros: filtrosFacturas,
                                    setter: setFiltrosFacturas,
                                    paginaSetter: setPaginaActualFacturas,
                                    labelBusqueda: 'N° Factura',
                                    placeholderBusqueda: 'N° Factura',
                                    opcionesEstado: [
                                        { value: '0', label: 'Generada' },
                                        { value: '1', label: 'Cobrada' },
                                        { value: '2', label: 'Por Cobrar' },
                                        { value: '3', label: 'Anulada' },
                                        { value: '4', label: 'Cobrada (No Elect.)' },
                                        { value: '5', label: 'Por Cobrar (No Elect.)' },
                                        { value: '6', label: 'Error DIAN' }
                                    ]
                                })}
                                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                    <table className="table custom-table mb-0">
                                        <colgroup>
                                            <col style={{ width: '16%' }} />
                                            <col style={{ width: '10%' }} />
                                            <col style={{ width: '16%' }} />
                                            <col style={{ width: '14%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '10%' }} />
                                            <col style={{ width: '10%' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>N° Factura</th>
                                                <th>Fecha</th>
                                                <th>Concepto</th>
                                                <th>Forma de pago</th>
                                                <th className="text-right">Total</th>
                                                <th>Tipo</th>
                                                <th>Estado</th>
                                                <th className="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {facturasPaginadas.length === 0 ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center">No hay facturas registradas</td>
                                                </tr>
                                            ) : (
                                                facturasPaginadas.map(factura => (
                                                    <tr
                                                        key={factura.id}
                                                        className={parseInt(factura.estado, 10) === 3 ? 'fila-anulado' : ''}
                                                    >
                                                        <td>
                                                            {factura.prefijo && factura.numero_factura ? (
                                                                <strong>{factura.prefijo}-{factura.numero_factura}</strong>
                                                            ) : factura.numero_factura ? (
                                                                <strong>{factura.numero_factura}</strong>
                                                            ) : (
                                                                <strong className="text-muted">#{factura.id}</strong>
                                                            )}
                                                        </td>
                                                        <td>{formatearFecha(factura.fecha_emision)}</td>
                                                        <td
                                                            className="concepto-cell"
                                                            title={factura.concepto_factura_nombre || ''}
                                                            style={{ whiteSpace: 'nowrap', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                        >
                                                            {factura.concepto_factura_nombre || '—'}
                                                        </td>
                                                        <td>
                                                            {factura.forma_pago && factura.forma_pago !== 'PENDIENTE'
                                                                ? getMedioPagoTexto(factura.forma_pago)
                                                                : '—'}
                                                        </td>
                                                        <td className="text-right">
                                                            ${Math.round(parseFloat(factura.valor_total || 0)).toLocaleString('es-CO')}
                                                        </td>
                                                        <td>
                                                            {[4, 5].includes(factura.estado) ? 'No electrónica' : 'Electrónica'}
                                                        </td>
                                                        <td>
                                                            <span className={getNestedEstadoChip(factura.estado)}>
                                                                {getEstadoTexto(factura.estado)}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-light shadow-sm"
                                                                onClick={() => abrirModalAcciones('factura', factura)}
                                                                style={{ borderRadius: '8px', padding: '4px 12px', background: 'white', color: '#323a45', border: '1px solid #f0f0f0' }}
                                                            >
                                                                <i className="fas fa-ellipsis-v"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Paginador Facturas */}
                                {facturasFiltradas.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {facturasFiltradas.length === 0 ? 0 : indicePrimerRegistroFacturas + 1} a {Math.min(indiceUltimoRegistroFacturas, facturasFiltradas.length)} de {facturasFiltradas.length} facturas
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActualFacturas === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaFacturas(paginaActualFacturas - 1)}
                                                            disabled={paginaActualFacturas === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>

                                                    {[...Array(totalPaginasFacturas)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        // Mostrar solo 5 páginas a la vez
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginasFacturas ||
                                                            (numeroPagina >= paginaActualFacturas - 1 && numeroPagina <= paginaActualFacturas + 1)
                                                        ) {
                                                            return (
                                                                <li
                                                                    key={numeroPagina}
                                                                    className={`page-item ${paginaActualFacturas === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => cambiarPaginaFacturas(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActualFacturas - 2 ||
                                                            numeroPagina === paginaActualFacturas + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}

                                                    <li className={`page-item ${paginaActualFacturas === totalPaginasFacturas ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaFacturas(paginaActualFacturas + 1)}
                                                            disabled={paginaActualFacturas === totalPaginasFacturas}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                </>
                                )}
                            </div>

                            {/* Tabla de Presupuestos del Paciente */}
                            <div className="card card-info card-outline">
                                <div
                                    className="card-header seccion-accordion-header"
                                    onClick={() => toggleSeccion('presupuestos')}
                                >
                                    <h3 className="card-title">
                                        <i className={`fas fa-chevron-${seccionesAbiertas.presupuestos ? 'down' : 'right'} mr-2`}></i>
                                        <i className="fas fa-calculator mr-2"></i> Presupuestos del Paciente
                                        <span className="seccion-count">{presupuestosFiltrados.length}</span>
                                        {renderBotonFiltro('presupuestos', filtrosPresupuestos)}
                                    </h3>
                                </div>

                                {seccionesAbiertas.presupuestos && (
                                <>
                                {filtrosVisibles.presupuestos && renderBarraFiltros({
                                    filtros: filtrosPresupuestos,
                                    setter: setFiltrosPresupuestos,
                                    paginaSetter: setPaginaActualPresupuestos,
                                    labelBusqueda: 'N° Presupuesto',
                                    placeholderBusqueda: 'N° Presupuesto',
                                    opcionesEstado: [
                                        { value: '0', label: 'Borrador' },
                                        { value: '1', label: 'Activo' },
                                        { value: '2', label: 'Anulado' },
                                        { value: '3', label: 'Pagado' }
                                    ]
                                })}
                                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                    <table className="table custom-table mb-0">
                                        <colgroup>
                                            <col style={{ width: '14%' }} />
                                            <col style={{ width: '10%' }} />
                                            <col style={{ width: '16%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '12%' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>N° Presupuesto</th>
                                                <th>Fecha</th>
                                                <th>Profesional</th>
                                                <th className="text-center">Total</th>
                                                <th className="text-center">Pagado</th>
                                                <th className="text-center">Saldo</th>
                                                <th className="text-center">Estado</th>
                                                <th className="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {presupuestosPaginados.length === 0 ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center">No hay presupuestos registrados</td>
                                                </tr>
                                            ) : (
                                                presupuestosPaginados.map(presupuesto => {
                                                    const estado = parseInt(presupuesto.estado);
                                                    const estadoTextos = { 0: 'Borrador', 1: 'Activo', 2: 'Anulado', 3: 'Pagado' };
                                                    const valorPagado = parseFloat(presupuesto.valor_consumido || 0);
                                                    const valorPendiente = parseFloat(presupuesto.saldo_disponible || 0);
                                                    return (
                                                        <tr key={presupuesto.id} className={estado === 2 ? 'fila-anulado' : ''}>
                                                            <td><strong>{presupuesto.numero_presupuesto}</strong></td>
                                                            <td>{formatearFecha(presupuesto.fecha_creacion)}</td>
                                                            <td>{getNombreUsuario(presupuesto.users_id)}</td>
                                                            <td className="text-center">
                                                                <strong>${Math.round(parseFloat(presupuesto.valor_total || 0)).toLocaleString('es-CO')}</strong>
                                                            </td>
                                                            <td className="text-center" style={{ color: '#28a745', fontWeight: 700 }}>
                                                                ${Math.round(valorPagado).toLocaleString('es-CO')}
                                                            </td>
                                                            <td className="text-center" style={{ color: valorPendiente > 0 ? '#dc3545' : '#28a745', fontWeight: 700 }}>
                                                                ${Math.round(valorPendiente).toLocaleString('es-CO')}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className={`estado-chip ${
                                                                    estado === 0 ? 'generado'
                                                                    : estado === 1 ? 'activo'
                                                                    : estado === 2 ? 'anulado'
                                                                    : estado === 3 ? 'por-cobrar'
                                                                    : 'generado'
                                                                }`}>
                                                                    {estadoTextos[estado] || 'Desconocido'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light shadow-sm"
                                                                    onClick={() => abrirModalAcciones('presupuesto', presupuesto)}
                                                                    style={{ borderRadius: '8px', padding: '4px 12px', background: 'white', color: '#323a45', border: '1px solid #f0f0f0' }}
                                                                >
                                                                    <i className="fas fa-ellipsis-v"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Paginador Presupuestos */}
                                {presupuestosFiltrados.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {presupuestosFiltrados.length === 0 ? 0 : indicePrimerRegistroPresupuestos + 1} a {Math.min(indiceUltimoRegistroPresupuestos, presupuestosFiltrados.length)} de {presupuestosFiltrados.length} presupuestos
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActualPresupuestos === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaPresupuestos(paginaActualPresupuestos - 1)}
                                                            disabled={paginaActualPresupuestos === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>

                                                    {[...Array(totalPaginasPresupuestos)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        // Mostrar solo 5 páginas a la vez
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginasPresupuestos ||
                                                            (numeroPagina >= paginaActualPresupuestos - 1 && numeroPagina <= paginaActualPresupuestos + 1)
                                                        ) {
                                                            return (
                                                                <li
                                                                    key={numeroPagina}
                                                                    className={`page-item ${paginaActualPresupuestos === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => cambiarPaginaPresupuestos(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActualPresupuestos - 2 ||
                                                            numeroPagina === paginaActualPresupuestos + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}

                                                    <li className={`page-item ${paginaActualPresupuestos === totalPaginasPresupuestos ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaPresupuestos(paginaActualPresupuestos + 1)}
                                                            disabled={paginaActualPresupuestos === totalPaginasPresupuestos}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                </>
                                )}
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal de Acciones Rápidas */}
                {showModalAcciones && registroAccion && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                                <div className="modal-header border-0 pb-0" style={{ background: '#f8f9fa' }}>
                                    <h6 className="modal-title font-weight-bold" style={{ color: '#323a45' }}>
                                        {tipoAccionSeleccionada === 'factura'
                                            ? `Opciones Factura ${registroAccion.prefijo ? `${registroAccion.prefijo}-` : ''}${registroAccion.numero_factura || `#${registroAccion.id}`}`
                                            : `Opciones Presupuesto N° ${registroAccion.numero_presupuesto}`}
                                    </h6>
                                    <button type="button" className="close" onClick={cerrarModalAcciones}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body p-3">
                                    <div className="list-group list-group-flush">
                                        {tipoAccionSeleccionada === 'factura' ? (
                                            <>
                                                <Link
                                                    to={`/informacion-factura/${registroAccion.id}`}
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px', background: '#f0f5ff' }}
                                                    onClick={cerrarModalAcciones}
                                                >
                                                    <i className="fas fa-info-circle mr-3" style={{ color: '#17a2b8' }}></i>
                                                    <span style={{ fontWeight: 600 }}>Ver información</span>
                                                </Link>

                                                {registroAccion.estado === 0 && (
                                                    <>
                                                        {tienePermiso('anular_facturas') && (
                                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { anularFactura(registroAccion.id, registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                                <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                            </button>
                                                        )}
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { reenviarFacturaDian(registroAccion.id); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-paper-plane mr-3 text-primary"></i><span style={{ fontWeight: 600 }}>Enviar a DIAN</span>
                                                        </button>
                                                    </>
                                                )}

                                                {registroAccion.estado === 1 && (
                                                    <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirModalNotaCredito(registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                        <i className="fas fa-file-invoice mr-3 text-danger"></i><span style={{ fontWeight: 600 }}>Nota crédito</span>
                                                    </button>
                                                )}

                                                {(registroAccion.estado === 2 || registroAccion.estado === 5) && (
                                                    <>
                                                        <button
                                                            className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                            onClick={() => {
                                                                if (registroAccion.estado === 5) abrirModalNotaCreditoNoElectronica(registroAccion);
                                                                else abrirModalNotaCredito(registroAccion);
                                                                cerrarModalAcciones();
                                                            }}
                                                            style={{ borderRadius: '12px' }}
                                                        >
                                                            <i className="fas fa-file-invoice-dollar mr-3 text-danger"></i><span style={{ fontWeight: 600 }}>Nota crédito</span>
                                                        </button>
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirModalRecibo(registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-money-bill-wave mr-3 text-success"></i><span style={{ fontWeight: 600 }}>Registrar abono</span>
                                                        </button>
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { verRecibos(registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-receipt mr-3 text-info"></i><span style={{ fontWeight: 600 }}>Ver abonos</span>
                                                        </button>
                                                    </>
                                                )}

                                                {registroAccion.estado === 4 && tienePermiso('anular_facturas') && (
                                                    <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { anularFactura(registroAccion.id, registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                        <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                    </button>
                                                )}

                                                {registroAccion.estado === 6 && (
                                                    <>
                                                        {tienePermiso('anular_facturas') && (
                                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { anularFactura(registroAccion.id, registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                                <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                            </button>
                                                        )}
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { reenviarFacturaDian(registroAccion.id); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-redo mr-3 text-primary"></i><span style={{ fontWeight: 600 }}>Reenviar a DIAN</span>
                                                        </button>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { vistaPreviaPresupuesto(registroAccion.id); cerrarModalAcciones(); }} style={{ borderRadius: '12px', background: '#f0f5ff' }}>
                                                    <i className="fas fa-eye mr-3 text-info"></i><span style={{ fontWeight: 600 }}>Vista previa</span>
                                                </button>
                                                {parseInt(registroAccion.estado) === 0 && (
                                                    <>
                                                        <Link to={`/editar-presupuesto/${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                            <i className="fas fa-edit mr-3 text-warning"></i><span style={{ fontWeight: 600 }}>Editar</span>
                                                        </Link>
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { cambiarEstadoPresupuesto(registroAccion.id, 1); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-check-circle mr-3 text-success"></i><span style={{ fontWeight: 600 }}>Aprobar</span>
                                                        </button>
                                                    </>
                                                )}
                                                {parseInt(registroAccion.estado) === 1 && (
                                                    <>
                                                        <Link to={`/editar-presupuesto/${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                            <i className="fas fa-edit mr-3 text-warning"></i><span style={{ fontWeight: 600 }}>Editar</span>
                                                        </Link>
                                                        {parseFloat(registroAccion.saldo_disponible || 0) > 0 && (
                                                            <>
                                                                <Link to={`/crear-factura?presupuesto_activo=${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                                    <i className="fas fa-file-invoice-dollar mr-3 text-success"></i><span style={{ fontWeight: 600 }}>Factura electrónica</span>
                                                                </Link>
                                                                <Link to={`/crear-factura-no-electronica?presupuesto_activo=${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                                    <i className="fas fa-receipt mr-3 text-secondary"></i><span style={{ fontWeight: 600 }}>Factura no electrónica</span>
                                                                </Link>
                                                            </>
                                                        )}
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { cambiarEstadoPresupuesto(registroAccion.id, 2); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                        </button>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Recibo de Caja */}
                {showModalRecibo && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-dialog-centered shadow-lg">
                            <div className="modal-content border-0" style={{ borderRadius: '16px' }}>
                                <div className="modal-header border-0 bg-light">
                                    <h6 className="modal-title font-weight-bold">Registrar Recibo</h6>
                                    <button type="button" className="close" onClick={() => setShowModalRecibo(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-4">
                                    <div className="form-group mb-3">
                                        <label className="small text-muted d-block">Factura / saldo pendiente</label>
                                        <div className="border rounded px-3 py-2 bg-light">
                                            <div className="font-weight-bold">N° {facturaSeleccionada?.numero_factura}</div>
                                            <div className="small text-muted mb-0">
                                                Saldo pendiente (informativo):{' '}
                                                <strong className="text-dark">${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="small text-muted">Valor a recibir</label>
                                        <div className="lf-recibo-valor-group">
                                            <span className="lf-recibo-moneda-icon" title="Pesos colombianos">
                                                <i className="fas fa-dollar-sign" aria-hidden="true"></i>
                                            </span>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                className="form-control lf-recibo-valor-input"
                                                value={valorRecibo}
                                                onChange={handleValorReciboChange}
                                                placeholder="0"
                                                autoComplete="off"
                                            />
                                        </div>
                                        <small className="text-muted">
                                            Máximo: ${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}
                                        </small>
                                    </div>
                                    <div className="form-group">
                                        <label className="small text-muted">Medio de Pago</label>
                                        <select className="form-control" value={medioPago} onChange={e => setMedioPago(e.target.value)}>
                                            {FORMA_PAGO_OPCIONES.map((op) => (
                                                <option key={op.value} value={op.value}>{op.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group"><label className="small text-muted">Fecha Pago</label><input type="date" className="form-control" value={fechaPago} onChange={e => setFechaPago(e.target.value)} /></div>
                                    <div className="form-group"><label className="small text-muted">Observaciones</label><textarea className="form-control" rows="2" value={observacionesRecibo} onChange={e => setObservacionesRecibo(e.target.value)}></textarea></div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button className="btn btn-light" onClick={() => setShowModalRecibo(false)}>Cancelar</button>
                                    <button className="btn btn-info px-4" style={{ borderRadius: '10px' }} onClick={guardarRecibo}>Guardar Pago</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Ver Recibos */}
                {showModalRecibos && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0" style={{ borderRadius: '16px' }}>
                                <div className="modal-header border-0 bg-light">
                                    <h6 className="modal-title font-weight-bold">Historial de Pagos - Factura #{facturaSeleccionada?.numero_factura}</h6>
                                    <button type="button" className="close" onClick={() => setShowModalRecibos(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-0">
                                    <div className="table-responsive">
                                        <table className="table mb-0 small">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th>Recibo</th>
                                                    <th>Fecha</th>
                                                    <th className="text-right">Valor</th>
                                                    <th>Medio</th>
                                                    <th>Estado</th>
                                                    <th>Observaciones</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {recibosFactura.map(recibo => (
                                                    <tr key={recibo.id}>
                                                        <td>{recibo.numero_recibo}</td>
                                                        <td>{formatearFecha(recibo.fecha_pago)}</td>
                                                        <td className="text-right font-weight-bold">{formatearValor(recibo.valor_pago)}</td>
                                                        <td>{getMedioPagoTexto(recibo.forma_pago)}</td>
                                                        <td><span className={`badge ${recibo.estado === 0 ? 'badge-danger' : 'badge-success'}`}>{recibo.estado === 0 ? 'Anulado' : 'Activo'}</span></td>
                                                        <td>{recibo.observaciones || '—'}</td>
                                                        <td>
                                                            <button className="btn btn-xs btn-outline-info mr-1" onClick={() => vistaPreviaRecibo(recibo)} title="Ver recibo"><i className="fas fa-eye"></i></button>
                                                            {recibo.estado !== 0 && (
                                                                <button className="btn btn-xs btn-outline-danger" onClick={() => anularRecibo(recibo.id)} title="Anular"><i className="fas fa-ban"></i></button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    {recibosFactura.length === 0 && (
                                        <div className="text-center p-4 text-muted small">No hay recibos registrados para esta factura.</div>
                                    )}
                                </div>
                                <div className="modal-footer border-0"><button className="btn btn-light" onClick={() => setShowModalRecibos(false)}>Cerrar</button></div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito Electrónica */}
                {showModalNotaCredito && (
                    <div className="modal fade show lf-ds-modal lf-nc-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050 }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content border-0 shadow">
                                <div className="modal-header lf-ds-modal-head">
                                    <h4 className="modal-title mb-0">
                                        <i className="fas fa-file-invoice mr-2 text-info"></i>
                                        Generar Nota Crédito Electrónica
                                    </h4>
                                    <button type="button" className="close" onClick={() => setShowModalNotaCredito(false)} aria-label="Cerrar">
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="lf-ds-alert-info-soft mb-3">
                                        <strong>Factura:</strong> {facturaSeleccionada?.numero_factura}<br />
                                        <strong>Paciente:</strong> {getNombreCompleto()}<br />
                                        {esFacturaContado(facturaSeleccionada) ? (
                                            <>
                                                <strong>Venta de contado:</strong> nota crédito por el <strong>valor total</strong> (${Math.round(getValorTotalNum(facturaSeleccionada)).toLocaleString('es-CO')}) — anulación completa.
                                            </>
                                        ) : (
                                            <>
                                                <strong>Saldo pendiente:</strong> ${Math.round(getSaldoPendienteNum(facturaSeleccionada)).toLocaleString('es-CO')}
                                            </>
                                        )}
                                    </div>

                                    {notasCreditoExistentes.length > 0 && (
                                        <div className="lf-ds-alert-caution-soft mb-3">
                                            <strong>Notas crédito ya registradas:</strong>
                                            <ul className="mb-0 mt-2 pl-3 small">
                                                {notasCreditoExistentes.map((nc) => (
                                                    <li key={nc.id}>
                                                        {nc.prefijo || ''}{nc.numero_nc || '—'}
                                                        {' · '}${Math.round(parseFloat(nc.valor_total || 0)).toLocaleString('es-CO')}
                                                        {nc.uuid ? ' · DIAN OK' : ''}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Prefijo *</label>
                                                <select className="form-control" value={prefijoSeleccionado} onChange={handlePrefijoChange} required>
                                                    <option value="">Seleccionar...</option>
                                                    {prefijos.map(prefijo => (
                                                        <option key={prefijo.id} value={prefijo.id}>{prefijo.prefijo}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Nota Crédito *</label>
                                                <input type="text" className="form-control" value={numeroNotaCredito} readOnly />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Nota Crédito *</label>
                                                <input type="date" className="form-control" value={fechaNotaCredito} onChange={(e) => setFechaNotaCredito(e.target.value)} required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Tipo de Nota Crédito *</label>
                                                <select
                                                    className="form-control"
                                                    value={tipoNotaCredito}
                                                    onChange={(e) => {
                                                        const nuevoTipo = e.target.value;
                                                        setTipoNotaCredito(nuevoTipo);
                                                        if (nuevoTipo === 'total') {
                                                            setValorNotaCredito(getImporteNcTipoTotal(facturaSeleccionada));
                                                        } else {
                                                            setValorNotaCredito('');
                                                        }
                                                    }}
                                                >
                                                    <option value="total">
                                                        {esFacturaContado(facturaSeleccionada)
                                                            ? 'Total (anulación completa — valor de la factura)'
                                                            : 'Total (saldo pendiente completo)'}
                                                    </option>
                                                    {!esFacturaContado(facturaSeleccionada) && (
                                                        <option value="parcial">Parcial (solo facturas a crédito)</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Valor a Acreditar *</label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend"><span className="input-group-text">$</span></div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorNotaCredito}
                                                        onChange={(e) => setValorNotaCredito(e.target.value)}
                                                        readOnly={tipoNotaCredito === 'total'}
                                                        max={esFacturaContado(facturaSeleccionada) ? getValorTotalNum(facturaSeleccionada) : getSaldoPendienteNum(facturaSeleccionada)}
                                                        required
                                                    />
                                                </div>
                                                {tipoNotaCredito === 'parcial' && (
                                                    <small className="form-text text-muted">Indique el valor a acreditar (no mayor al saldo pendiente).</small>
                                                )}
                                                {tipoNotaCredito === 'total' && esFacturaContado(facturaSeleccionada) && (
                                                    <small className="form-text text-info">Se emite por el valor total de la factura (venta de contado).</small>
                                                )}
                                                {tipoNotaCredito === 'total' && !esFacturaContado(facturaSeleccionada) && (
                                                    <small className="form-text text-info">Se acreditará el saldo pendiente completo.</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group mb-0">
                                                <label>Motivo *</label>
                                                <textarea className="form-control" rows="3" value={motivoNotaCredito} onChange={(e) => setMotivoNotaCredito(e.target.value)} placeholder="Describa la razón de la nota crédito..." required />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0 bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCredito(false)} disabled={loadingNC}>Cancelar</button>
                                    <button type="button" className="btn btn-info" onClick={generarNotaCredito} disabled={loadingNC || (esFacturaContado(facturaSeleccionada) && notasCreditoExistentes.length > 0)}>
                                        {loadingNC ? (
                                            <><i className="fas fa-spinner fa-spin mr-1"></i> Enviando a DIAN...</>
                                        ) : (
                                            <><i className="fas fa-paper-plane mr-1"></i> Generar y Enviar a DIAN</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal resultado envío DIAN */}
                {showModalDebug && (
                    <div
                        className={`modal fade show lf-ds-modal lf-dian-debug-modal${debugType !== 'success' ? ' lf-dian-debug-modal--wide' : ''}`}
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050 }}
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                            <div className="modal-content border-0 shadow">
                                <div className="modal-header lf-ds-modal-head align-items-center">
                                    <h5 className="modal-title mb-0 d-flex align-items-center font-weight-bold">
                                        {debugType === 'success' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(40, 167, 69, 0.12)', color: '#28a745' }}>
                                                <i className="fas fa-check"></i>
                                            </span>
                                        )}
                                        {debugType !== 'success' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(220, 53, 69, 0.12)', color: '#dc3545' }}>
                                                <i className="fas fa-exclamation"></i>
                                            </span>
                                        )}
                                        {debugType === 'success' ? 'Envío a la DIAN' : (debugData?.titulo || 'No se pudo enviar a la DIAN')}
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalDebug(false)} aria-label="Cerrar">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body pt-3 pb-2">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="lf-ds-alert-success-soft mb-0">
                                                <strong className="d-block mb-1">{mensajeClienteSinCodigoEstado(debugData?.message || 'Operación completada.')}</strong>
                                                <span className="text-muted small d-block" style={{ lineHeight: 1.45 }}>
                                                    El proveedor de emisión confirmó el documento. Guarde el CUDE o UUID para sus registros.
                                                </span>
                                            </div>
                                            <div className="lf-ds-dian-detail-panel">
                                                <div className="lf-dian-label">CUDE / UUID</div>
                                                <div className="lf-dian-uuid">{debugData?.uuid || debugData?.cufe || '—'}</div>
                                                {debugData?.numero_nc ? (
                                                    <div className="mt-3">
                                                        <div className="lf-dian-label">Nota crédito</div>
                                                        <span className="lf-dian-badge badge badge-success">{debugData.numero_nc}</span>
                                                        {debugData?.recibos_anulados > 0 && (
                                                            <span className="lf-dian-badge badge badge-warning ml-2">Recibos anulados: {debugData.recibos_anulados}</span>
                                                        )}
                                                    </div>
                                                ) : null}
                                                {(debugData?.pdf_url || debugData?.xml_url) && (
                                                    <div className="mt-3">
                                                        <div className="lf-dian-label mb-2">Documentos DIAN</div>
                                                        <div className="btn-group" role="group">
                                                            {debugData.pdf_url && (
                                                                <a
                                                                    href={debugData.pdf_url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    download
                                                                >
                                                                    <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                                                                </a>
                                                            )}
                                                            {debugData.xml_url && (
                                                                <a
                                                                    href={debugData.xml_url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-success"
                                                                    download
                                                                >
                                                                    <i className="fas fa-file-code mr-1"></i> Descargar XML
                                                                </a>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-info"
                                                        onClick={() => {
                                                            const p = getSpaPathPrefix();
                                                            window.location.href = `${window.location.origin}${p}/#/informacion-factura/${debugData.facturaId}`;
                                                        }}
                                                    >
                                                        <i className="fas fa-file-invoice mr-1"></i> Ver factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="lf-ds-alert-danger-soft mb-3">
                                                <strong className="d-block mb-1">Detalle</strong>
                                                <span style={{ lineHeight: 1.5 }}>{mensajeClienteSinCodigoEstado(debugData?.message || 'Ocurrió un error al comunicarse con el servicio de emisión.')}</span>
                                            </div>
                                            {debugData?.response && (
                                                <div className="lf-ds-dian-detail-panel mb-3">
                                                    <div className="lf-dian-label">Respuesta del servicio</div>
                                                    <pre className="mb-0" style={{ backgroundColor: '#f4f6f8', padding: '12px 14px', borderRadius: '8px', maxHeight: '280px', overflow: 'auto', fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', border: '1px solid rgba(0,0,0,0.06)', fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace' }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                </div>
                                            )}
                                            {debugData?.json_enviado && (
                                                <div className="lf-ds-dian-detail-panel mb-0">
                                                    <div className="lf-dian-label">JSON enviado (soporte técnico)</div>
                                                    <pre className="mb-0" style={{ backgroundColor: '#f4f6f8', padding: '12px 14px', borderRadius: '8px', maxHeight: '280px', overflow: 'auto', fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', border: '1px solid rgba(0,0,0,0.06)', fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace' }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                </div>
                                            )}
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button type="button" className="btn btn-outline-info" onClick={() => { const p = getSpaPathPrefix(); window.location.href = `${window.location.origin}${p}/#/informacion-factura/${debugData.facturaId}`; }}>
                                                        <i className="fas fa-file-invoice mr-1"></i> Ver factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito No Electrónica */}
                {showModalNotaCreditoNE && consecutivoNCNE && (
                    <div className="modal fade show lf-ds-modal lf-nc-ne-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050, overflowY: 'auto' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header lf-ds-modal-head">
                                    <h5 className="modal-title mb-0">
                                        <i className="fas fa-file-invoice mr-2 text-info"></i>
                                        Nota crédito — factura no electrónica
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalNotaCreditoNE(false)} aria-label="Cerrar">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form onSubmit={generarNotaCreditoNE}>
                                    <div className="modal-body">
                                        <div className="lf-ds-alert-caution-soft mb-3">
                                            <i className="fas fa-info-circle mr-2 text-warning" style={{ opacity: 0.85 }}></i>
                                            Se registrará la nota crédito en el sistema, se actualizarán saldos y se consumirá el consecutivo de NC no electrónica. No aplica envío a la DIAN.
                                        </div>

                                        <div className="lf-ds-alert-info-soft mb-3">
                                            <strong>Factura:</strong>{' '}
                                            {facturaSeleccionada?.prefijo ? `${facturaSeleccionada.prefijo}-` : ''}{facturaSeleccionada?.numero_factura}
                                            <br />
                                            <strong>Paciente:</strong> {getNombreCompleto()}
                                            <br />
                                            {esFacturaContado(facturaSeleccionada) ? (
                                                <>
                                                    <strong>Venta de contado:</strong> nota por el <strong>valor total</strong> (${Math.round(getValorTotalNum(facturaSeleccionada)).toLocaleString('es-CO')}).
                                                </>
                                            ) : (
                                                <>
                                                    <strong>Saldo pendiente:</strong> ${Math.round(getSaldoPendienteNum(facturaSeleccionada)).toLocaleString('es-CO')}
                                                </>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>Consecutivo nota crédito</label>
                                            <input
                                                type="text"
                                                className="form-control bg-light"
                                                readOnly
                                                value={(() => {
                                                    const pr = consecutivoNCNE.prefijo != null && String(consecutivoNCNE.prefijo).trim() !== '' ? String(consecutivoNCNE.prefijo).trim() : null;
                                                    const co = consecutivoNCNE.consecutivo;
                                                    if (pr != null && co != null) return `${pr}-${co}`;
                                                    if (co != null) return String(co);
                                                    return '—';
                                                })()}
                                            />
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tipo de nota *</label>
                                                    <select
                                                        className="form-control"
                                                        value={esFacturaContado(facturaSeleccionada) ? 'total' : tipoNotaCreditoNE}
                                                        onChange={(e) => {
                                                            const nuevoTipo = e.target.value;
                                                            setTipoNotaCreditoNE(nuevoTipo);
                                                            if (nuevoTipo === 'total') {
                                                                setValorNotaCreditoNE(getImporteNcTipoTotal(facturaSeleccionada));
                                                            } else {
                                                                setValorNotaCreditoNE('');
                                                            }
                                                        }}
                                                        disabled={esFacturaContado(facturaSeleccionada)}
                                                    >
                                                        <option value="total">
                                                            {esFacturaContado(facturaSeleccionada)
                                                                ? 'Total (anulación completa — valor de la factura)'
                                                                : 'Total (saldo pendiente completo)'}
                                                        </option>
                                                        {!esFacturaContado(facturaSeleccionada) && (
                                                            <option value="parcial">Parcial (solo facturas a crédito)</option>
                                                        )}
                                                    </select>
                                                    {esFacturaContado(facturaSeleccionada) && (
                                                        <small className="form-text text-muted">En contado solo aplica nota total.</small>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fecha emisión *</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={fechaNotaCreditoNE}
                                                        onChange={(e) => setFechaNotaCreditoNE(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Valor a acreditar *</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={valorNotaCreditoNE}
                                                    onChange={(e) => setValorNotaCreditoNE(e.target.value)}
                                                    readOnly={tipoNotaCreditoNE === 'total' || esFacturaContado(facturaSeleccionada)}
                                                    min={0}
                                                    step={1}
                                                    max={esFacturaContado(facturaSeleccionada) ? getValorTotalNum(facturaSeleccionada) : getSaldoPendienteNum(facturaSeleccionada)}
                                                    required
                                                />
                                            </div>
                                            {tipoNotaCreditoNE === 'parcial' && !esFacturaContado(facturaSeleccionada) && (
                                                <small className="form-text text-muted">No mayor al saldo pendiente.</small>
                                            )}
                                        </div>

                                        <div className="form-group mb-0">
                                            <label>Motivo *</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={motivoNotaCreditoNE}
                                                onChange={(e) => setMotivoNotaCreditoNE(e.target.value)}
                                                placeholder="Describa la razón de la nota crédito..."
                                                required
                                            />
                                        </div>

                                        {!esFacturaContado(facturaSeleccionada) && tipoNotaCreditoNE === 'total' && (
                                            <p className="text-muted small mb-0 mt-2">Se acreditará el saldo pendiente completo.</p>
                                        )}
                                    </div>
                                    <div className="modal-footer border-top bg-light">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCreditoNE(false)}>Cancelar</button>
                                        <button type="submit" className="btn btn-info" disabled={loadingNCNE}>
                                            {loadingNCNE ? (
                                                <i className="fas fa-spinner fa-spin mr-1"></i>
                                            ) : (
                                                <i className="fas fa-check mr-1"></i>
                                            )}
                                            Generar nota crédito
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal éxito recibo de caja */}
                {showModalExitoRecibo && reciboGuardado && (
                    <Modal
                        show={showModalExitoRecibo}
                        onHide={() => { setShowModalExitoRecibo(false); setReciboGuardado(null); }}
                        centered
                        dialogClassName="mx-exito-dialog"
                        contentClassName="mx-exito-content"
                    >
                        <Modal.Header closeButton className="mx-exito-head">
                            <Modal.Title>
                                <span className="mx-exito-head-icon">
                                    <i className="fas fa-check"></i>
                                </span>
                                Recibo registrado
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="mx-exito-body">
                            <div className="mx-exito-hero" aria-hidden="true">
                                <i className="fas fa-check"></i>
                            </div>
                            <h5 className="mx-exito-title">Recibo registrado exitosamente</h5>
                            <p className="mx-exito-label mb-0">Número de Recibo:</p>
                            <div className="mx-exito-numero">
                                {reciboGuardado.numero_recibo
                                    || (reciboGuardado.recibo_id != null ? String(reciboGuardado.recibo_id) : '—')}
                            </div>
                            <p className="text-muted small mt-2 mb-0">
                                Valor:{' '}
                                <strong>
                                    ${Math.round(parseFloat(reciboGuardado.valor_pago || reciboGuardado.valor_recibido || parseMontoRecibo(valorRecibo) || 0)).toLocaleString('es-CO')}
                                </strong>
                                {facturaSeleccionada?.numero_factura && (
                                    <> · Factura N° {facturaSeleccionada.numero_factura}</>
                                )}
                            </p>
                        </Modal.Body>
                        <Modal.Footer className="mx-exito-footer">
                            <Button
                                className="mx-exito-btn-outline mx-exito-btn-outline--teal"
                                onClick={() => {
                                    vistaPreviaRecibo(reciboGuardado);
                                }}
                            >
                                <i className="fas fa-eye mr-2"></i> Ver / imprimir
                            </Button>
                            <Button
                                className="mx-exito-btn-outline mx-exito-btn-outline--gray"
                                onClick={() => { setShowModalExitoRecibo(false); setReciboGuardado(null); }}
                            >
                                <i className="fas fa-times mr-2"></i> Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default EstadoCuentaPaciente;
